var Text = 'Text';
var Binary = 'Binary';
var Image = 'Image';
var Mesh = 'Mesh';

module.exports = {
  Text: Text,
  Binary: Binary,
  Image: Image,
  Mesh: Mesh
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/itk/IOTypes.js
// module id = 15
// module chunks = 0